/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaLightboxViewProps } from './citta-lightbox';

export default (props: ICittaLightboxViewProps) => {
    const { CittaLighboxContainer, LaunchLighboxButton, ModalPopUp } = props;
    return (
        <Module {...CittaLighboxContainer}>
            {LaunchLighboxButton}
            {ModalPopUp}
        </Module>
    );
};
